// ================================================================
// svc-table 行高さ均等化
// ================================================================

function equalizeTableRows() {
  const tables = document.querySelectorAll('.svc-table__inner');

  tables.forEach((table) => {
    const groups = table.querySelectorAll('.svc-table__group');
    if (groups.length === 0) return;

    const itemsByGroup = Array.from(groups).map((group) =>
      Array.from(group.querySelectorAll('.svc-table__item'))
    );

    const maxRows = Math.max(...itemsByGroup.map((items) => items.length));

    for (let row = 0; row < maxRows; row++) {
      const rowItems = itemsByGroup
        .map((items) => items[row])
        .filter(Boolean);

      rowItems.forEach((item) => {
        item.style.height = '';
      });

      const maxHeight = Math.max(
        ...rowItems.map((item) => item.offsetHeight)
      );

      rowItems.forEach((item) => {
        item.style.height = maxHeight + 'px';
      });
    }
  });
}

let resizeTimer;

export function initTableRowHeight() {
  equalizeTableRows();

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeTableRows, 200);
  });
}
